import React, { useEffect } from "react";
import styled from "styled-components";
import MuuriGrid from "muuri";
import "./style.css";

import { playSong } from "./actions";
import { Box } from "../../../comps";

const base = 6;

const GridWrapper = styled(Box)`
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const GridItem = styled.div`
  height: ${({ h }) => h}px;
  width: ${({ w }) => w}px;
  display: block;
  box-sizing: border-box;
  transition: opacity 0.3s;
  &:hover {
    border: 2px solid ${({ theme }) => theme.color.RED_6};
  }
`;

const Img = styled.img`
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;

const w = [90, 180, 270];

export default ({ songs }) => {
  useEffect(() => {
    const grid = new MuuriGrid(".grid", {
      dragEnabled: true,
      // dragAxis: 'y',
      layout: { fillGaps: true, alignLeft: true, alignTop: true },
    });
  }, []);

  return (
    <GridWrapper>
      <div class="grid">
        {songs.map((song, idx) => {
          if (!song) return <></>;
          const { thumbnails } = song;
          const imgSrc =
            (thumbnails && (thumbnails.mediumUrl || thumbnails.standardUrl)) ||
            "";
          if (!imgSrc) return <></>;
          const r = Math.floor(Math.random() * 3) + 1;
          // const ran = r === 1 ? base / 2 : r === 2 ? base : base * 2;
          // const width = ran * 16;
          // const height = ran * 9;
          const width = w[r - 1];
          const height = (w[r - 1] * 9.0) / 16;
          return (
            <GridItem className={"item"} w={width} h={height}>
              <div class="item-content">
                <Img
                  src={imgSrc}
                  onClick={() => {
                    playSong({ queue: songs, idx });
                  }}
                />
              </div>
            </GridItem>
          );
        })}
      </div>
    </GridWrapper>
  );
};
